export const categories = [
  { value: 'Resume Writing', label: 'Resume Writing' },
  { value: 'Improve Profile', label: 'Improve Profile' },
  { value: 'Mock Interviews', label: 'Mock Interviews' },
  { value: 'Data Structure and Algorithms', label: 'Data Structure and Algorithms' },
  { value: 'Code Review', label: 'Code Review' },
];


